/******************************************************************************
 *
 * FILE:
 * src/modules/wms/workspace/approval/components/ApprovalFooter.jsx
 *
 * MODULE:
 * Work Management System (WMS)
 *
 * FEATURE:
 * Approval Workspace
 *
 * DESCRIPTION:
 * Footer for Approval Workspace.
 *
 ******************************************************************************/

import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

import approvalWorkspaceService
    from "../services/approvalWorkspaceService";

export default function ApprovalFooter({

    work,

    permissions,

    onRefresh,
    setPageLoading,

}) {

    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    // ==========================================================
    // APPROVE
    // ==========================================================

    const handleApprove = async () => {

        if (!window.confirm("Approve this work?")) {
            return;
        }

        try {

            setLoading(true);
            if (setPageLoading) {
                setPageLoading(true);
            }

            await approvalWorkspaceService.approveWork(
                work.id
            );

            alert("Work approved successfully.");

            //if (onRefresh) {
            //    await onRefresh();
            //}
            navigate("/wms/approval-workspace", {
                replace: true,
            });

        }
        catch (error) {

            console.error(error);

            alert("Unable to approve work.");

        }
        finally {

            setLoading(false);
            if (setPageLoading) {
                setPageLoading(false);
            }

        }

    };

    // ==========================================================
    // REJECT
    // ==========================================================

    const handleReject = async () => {

        const reason = window.prompt(
            "Enter rejection reason:",
            ""
        );

        if (reason === null) {
            return;
        }

        try {

            setLoading(true);
            if (setPageLoading) {
                setPageLoading(true);
            }

            await approvalWorkspaceService.rejectWork(
                work.id,
                reason
            );

            alert("Work rejected successfully.");

            //if (onRefresh) {
            //    await onRefresh();
            //}
            navigate("/wms/approval-workspace", {
                replace: true,
            });

        }
        catch (error) {

            console.error(error);

            alert("Unable to reject work.");

        }
        finally {

            setLoading(false);
            if (setPageLoading) {
                setPageLoading(false);
            }

        }

    };

    // ==========================================================
    // SEND BACK
    // ==========================================================

    const handleSendBack = async () => {

        const comments = window.prompt(
            "Enter send back comments:",
            ""
        );

        if (comments === null) {
            return;
        }

        try {

            setLoading(true);
            if (setPageLoading) {
                setPageLoading(true);
            }

            await approvalWorkspaceService.sendBackWork(
                work.id,
                comments
            );

            alert("Work sent back successfully.");

            //if (onRefresh) {
            //    await onRefresh();
            //}
            navigate("/wms/approval-workspace", {
                replace: true,
            });

        }
        catch (error) {

            console.error(error);

            alert("Unable to send back work.");

        }
        finally {

            setLoading(false);
            if (setPageLoading) {
                setPageLoading(false);
            }

        }

    };

    // ==========================================================
    // RENDER
    // ==========================================================

    return (

        <div className="card shadow-sm mt-4">

            <div className="card-body d-flex justify-content-end gap-2">

                {
                    permissions?.can_send_back && (

                        <button
                            className="btn btn-warning"
                            disabled={loading}
                            onClick={handleSendBack}
                        >
                            Send Back
                        </button>

                    )
                }

                {
                    permissions?.can_reject && (

                        <button
                            className="btn btn-danger"
                            disabled={loading}
                            onClick={handleReject}
                        >
                            Reject
                        </button>

                    )
                }

                {
                    permissions?.can_approve && (

                        <button
                            className="btn btn-success"
                            disabled={loading}
                            onClick={handleApprove}
                        >
                            Approve
                        </button>

                    )
                }

            </div>

        </div>

    );

}